import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import {
  Input,
  Button,
  Form,
  Icon,
  Popup,
  Modal,
} from 'semantic-ui-react';
import {
  findById,
  findByIdAndUpdate,
  reenviarEmailHash,
  gerarNovoHashUnidade,
} from '../../../actions/unidade';
import {
  findByDocumento as findResponsavelByDocumento,
  resetState as resetStateResponsavel,
} from '../../../actions/responsavel';
import * as FormValidator from '../../../utils/formValidator';
import Erro from '../../layouts/mensagens/Erro';
import Sucesso from '../../layouts/mensagens/Sucesso';
import MenuVertical from '../../layouts/MenuVertical';
import InputMask from 'react-text-mask';
import { formatDocumento } from '../../../utils/formatador';
import api from '../../../api';

class EditarUnidade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      condominio: {},
      unidade: props.unidade,
      errors: {},
      errorsResponsavel: {},
      sucesso: false,
      loading: true,
      loadingResponsavel: false,
      loadingEmail: false,
      responsavelCadastrado: true,
      responsavelBuscadoExiste: false,
      openModal: false,
      loadingHash: false,
      sucessoNovoHash: false,
    };
  }

  componentDidMount = async () => {
    await this.props.findById(this.props.match.params.id);

    try {
      const condominio = await api.condominio.findSimpleById(this.props.match.params.condominioId);
      this.props.resetStateResponsavel();
      this.setState({
        condominio,
        unidade: {
          ...this.props.unidade,
          responsavel: this.props.unidade.responsavel || this.props.responsavel,
          condominio: condominio._id,
        },
        loading: false,
      });
    } catch (e) {
      this.setState({
        errors: (e.data && e.data.errors) || {},
        loading: false,
      });
    }
  };

  onChange = (e) => {
    this.setState({
      unidade: {
        ...this.state.unidade,
        [e.target.name]: e.target.value,
      },
      errors: {},
      sucesso: false,
    });
  };

  onChangeTokenEmail = () => {
    this.setState({
      unidade: {
        ...this.state.unidade,
        enviarTokenEmail: !this.state.unidade.enviarTokenEmail,
      },
      errors: {},
    });
  };

  onChangeResponsavel = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === 'documento') {
      clearInterval(this.state.busca);

      const documento = value.replace(/\D/g, '');
      const tipoDocumento = documento.length > 11 ? 'CNPJ' : 'CPF';

      this.setState({
        unidade: {
          ...this.state.unidade,
          responsavel: {
            ...this.state.unidade.responsavel,
            documento,
            tipoDocumento,
            nome: '',
            email: '',
            celular: '',
          },
        },
        errors: {},
        errorsResponsavel: {},
        loadingResponsavel: false,
        responsavelBuscadoExiste: false,
      });

      if (documento.length === 11 || documento.length === 14) {
        this.findResponsavelByDocumento(documento, tipoDocumento);
      }
    } else {
      this.setState({
        unidade: {
          ...this.state.unidade,
          responsavel: {
            ...this.state.unidade.responsavel,
            [name]: value,
          },
        },
        errors: {},
        errorsResponsavel: {},
      });
    }
  };

  findResponsavelByDocumento = (documento, tipoDocumento) => {
    if (tipoDocumento === 'CPF' && !FormValidator.isCpf(documento)) {
      this.setState({ errorsResponsavel: { documento: 'CPF Inválido' } });
      return;
    }

    if (tipoDocumento === 'CNPJ' && !FormValidator.isCnpj(documento)) {
      this.setState({ errorsResponsavel: { documento: 'CNPJ Inválido' } });
      return;
    }

    this.setState({
      loadingResponsavel: true,
      busca: setTimeout(async () => {
        await this.props.findResponsavelByDocumento(documento);

        let newState = {
          errorsResponsavel: this.props.errorsResponsavel,
          errors: this.props.errors,
          loadingResponsavel: false,
        };

        if (
          FormValidator.objIsEmpty(this.props.errors) &&
          FormValidator.objIsEmpty(this.props.errorsResponsavel)
        ) {
          newState = {
            ...newState,
            unidade: {
              ...this.state.unidade,
              responsavel: this.props.responsavel,
            },
            responsavelCadastrado: true,
            responsavelBuscadoExiste: true,
          };
        } else {
          newState = {
            ...newState,
            responsavel: {
              nome: '',
              email: '',
              telefone: '',
              documento,
              tipoDocumento,
            },
            responsavelCadastrado: false,
          };
        }

        this.setState(newState);
      }, 1500),
    });
  };

  validate = (unidade) => {
    const errors = {};
    const { condominio } = this.state;

    if (FormValidator.isVazio(unidade.numero)) {
      errors.numero = 'Número/Identificador é obrigatório';
    }

    if (condominio && condominio.usarFracaoIdeal && !unidade.fracao) {
      errors.fracao = 'Fração é obrigatório';
    }

    if (
      FormValidator.isVazio(unidade.responsavel.documento.replace(/\D/g, ''))
    ) {
      errors.documento = 'Responsável obrigatório';
    } else if (
      !FormValidator.isCpf(unidade.responsavel.documento) &&
      !FormValidator.isCnpj(unidade.responsavel.documento)
    ) {
      errors.documento = 'Documento inválido';
    }

    if (!this.state.responsavelExists) {
      if (
        FormValidator.isVazio(unidade.responsavel.nome) ||
        !FormValidator.isNomeCompleto(unidade.responsavel.nome)
      ) {
        errors.nome = 'Digite o nome completo';
      }

      if (
        !FormValidator.isVazio(unidade.responsavel.email) &&
        !FormValidator.isEmail(unidade.responsavel.email)
      ) {
        errors.email = 'Insira um email válido';
      }
    }

    return errors;
  };

  onSubmitEditarDados = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.unidade);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      await this.props.findByIdAndUpdate(
        this.state.unidade._id,
        this.state.unidade
      );
      this.setState({
        loading: false,
        sucesso: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors,
      });
    }
  };

  disabledFields = () => {
    return !!(
      this.state.loadingResponsavel ||
      this.state.responsavelCadastrado ||
      !this.state.unidade.responsavel.documento ||
      (!FormValidator.isCpf(this.state.unidade.responsavel.documento) &&
        this.state.unidade.responsavel.tipoDocumento === 'CPF') ||
      (!FormValidator.isCnpj(this.state.unidade.responsavel.documento) &&
        this.state.unidade.responsavel.tipoDocumento === 'CNPJ')
    );
  };

  reenviarEmailHash = async (e) => {
    e.preventDefault();
    this.setState({ loadingEmail: true });
    await this.props.reenviarEmailHash(this.state.unidade._id);
    this.setState({
      loadingEmail: false,
      sucessoEmail: FormValidator.objIsEmpty(this.props.errors),
    });
  };

  podeEnviarWhatsApp = () =>
    this.props.unidade.responsavel &&
    !FormValidator.isVazio(this.props.unidade.responsavel.celular);

  getLinkWhatsApp = () => {
    const unidade = this.props.unidade;
    const condominio = this.state.condominio;

    const url = 'https://api.whatsapp.com/send';
    const text =
      `Olá ${unidade.responsavel.nome}, o administrador do ${condominio.nome} ` +
      `incluiu você à unidade votante ${unidade.bloco}-${unidade.numero} em nosso APP de votação. ` +
      `Para votar, utilize o TOKEN de acesso *${unidade.hash}* e baixe o APP Vote Assembleia das lojas ` +
      `Google Play: https://play.google.com/store/apps/details?id=br.com.voteassembleia.app OU ` +
      `Apple Store: https://apps.apple.com/br/app/vote-assembleia/id1544152783`;

    return `${url}?phone=55${unidade.responsavel.celular}&text=${text}`;
  };

  handleModal = e =>{
    e.preventDefault();
    this.setState({
      openModal: !this.state.openModal,
    });
  };

  gerarNovoHashClickHandler = e => {
    e.preventDefault();
    this.setState({ loadingHash: true });
    this.props.gerarNovoHashUnidade({
          currentUnidadeId: this.state.unidade._id,
          responsavelId: this.state.unidade.responsavel._id,
          condominoId: this.state.condominio._id,
    }).then(()=>{
      this.setState({
        unidade:{
          ...this.state.unidade,
          hash: this.props.unidade.hash,
        },
        loadingHash: false,
        sucessoNovoHash: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors,
        openModal:false,
      });
    });
  };

  gerarNovoHash = () => {
    return <Modal
      trigger={
        <Popup
          content={'Clique aqui para gerar um novo token para a unidade votante.'}
          position='top center'
          size="large"
          trigger={
            <Button
              type="button"
              basic
              className="va-btn-acao va-btn-editar"
              disabled={this.state.sucessoNovoHash}
              loading={this.state.loadingHash}
              onClick={this.handleModal}
            >
              <Icon name="sync alternate" /> Gerar Novo Token
            </Button>
          }
        />
      }
      open={this.state.openModal}
      header='Confirmação'
      content={'Deseja gerar um novo token? Essa ação é irreversível e afetará todas as unidades votantes vinculadas ao responsável. Atenção! A(s) unidade(s) só terá(ão) acesso ao APP de votação com o novo token gerado!'}
      actions={[
        { key: 'close', content: 'Não', className: 'btn-ui-1 btn-ui-1-basic', onClick: this.handleModal},
        { key: 'done', content: 'Sim', className: 'btn-ui-1', onClick: this.gerarNovoHashClickHandler }
      ]}
    />
  };

  copiarToken = () => {
    if (navigator.clipboard && this.state.unidade.hash) {
      navigator.clipboard.writeText(this.state.unidade.hash).then(() => {
        this.setState({ tokenCopiado: true });
        setTimeout(() => this.setState({ tokenCopiado: false }), 2000);
      });
    }
  };

  render() {
    const {
      unidade,
      errors,
      errorsResponsavel,
      loading,
      loadingEmail,
      sucessoEmail,
      loadingResponsavel,
      sucesso,
      responsavelCadastrado,
      responsavelBuscadoExiste,
      condominio,
      sucessoNovoHash,
      tokenCopiado,
    } = this.state;
    const responsavel = unidade.responsavel || {};
    const identificacao = [unidade.bloco, unidade.numero].filter(Boolean).join(' ');
    const semResponsavel = !unidade.responsavel || !unidade.responsavel.documento;
    const voltar = `/condominios/${condominio._id || this.props.match.params.condominioId}/unidades`;

    return (
      <div>
        {!!errors.global && <Redirect to='/' />}
        <MenuHorizontal />
        <div className='corpo-dashboard'>
          <MenuVertical condominio={condominio} />
          <div className='va-imp-pagina'>
            <header className='va-un-cabecalho'>
              <div>
                <Link to={voltar} className='va-edit-voltar'><Icon name='arrow left' /> Unidades votantes</Link>
                <h1>Editar unidade votante{identificacao ? ` · ${identificacao}` : ''}</h1>
                <p>Altere os dados da unidade e do proprietário ou envie novamente o token de acesso ao aplicativo.</p>
              </div>
            </header>

            {sucesso && (
              <div className='va-res-banner sucesso' role='status'>
                <Icon name='check circle outline' size='big' />
                <div>
                  <b>Unidade votante editada com sucesso</b>
                  <p>As alterações já estão valendo.</p>
                  <div className='va-res-acoes'>
                    <Link to={voltar} className='ui button btn-ui-1 small'><Icon name='home' /> Voltar para as unidades</Link>
                  </div>
                </div>
              </div>
            )}

            {!sucesso && (
              <Form onSubmit={this.onSubmitEditarDados} loading={loading} autoComplete='off' className='va-imp'>
                <section className='va-imp-bloco'>
                  <h3><Icon name='key' /> Acesso ao aplicativo</h3>
                  <p>O proprietário usa este token para entrar no aplicativo de votação.</p>
                  {sucessoEmail ? (
                    <Sucesso style={{ fontSize: '1em' }} text={'Email enviado com sucesso'} size='big' />
                  ) : (
                    <>
                      <div className='va-edit-token'>
                        <code>{unidade.hash}</code>
                        <button type='button' className='va-edit-copiar' onClick={this.copiarToken}>
                          <Icon name={tokenCopiado ? 'check' : 'copy outline'} /> {tokenCopiado ? 'Copiado' : 'Copiar'}
                        </button>
                      </div>
                      <div className='va-edit-acoes'>
                        <Button type='button' className='btn-ui-1' onClick={this.reenviarEmailHash} disabled={semResponsavel} loading={loadingEmail}>
                          <Icon name='envelope' /> Reenviar e-mail com o token
                        </Button>
                        {this.podeEnviarWhatsApp() && (
                          <Button type='button' positive as='a' href={this.getLinkWhatsApp()} target='_blank' rel='noopener noreferrer' disabled={semResponsavel}>
                            <Icon name='whatsapp' /> Enviar pelo WhatsApp
                          </Button>
                        )}
                        {this.gerarNovoHash()}
                      </div>
                      {sucessoNovoHash && <Sucesso style={{ fontSize: '1em' }} text={'Novo token gerado com sucesso'} size='big' />}
                    </>
                  )}
                </section>

                <section className='va-imp-bloco'>
                  <h3><Icon name='home' /> Dados da unidade</h3>
                  <Form.Group widths='equal'>
                    <Form.Field error={!!errors.bloco}>
                      <label htmlFor='bloco'>Bloco/Grupo <small>(opcional)</small></label>
                      <Input id='bloco' name='bloco' type='text' placeholder='Ex.: A' onChange={this.onChange} value={unidade.bloco || ''} />
                      <Erro text={errors.bloco} />
                    </Form.Field>
                    <Form.Field error={!!errors.numero} required>
                      <label htmlFor='numero'>Número/Identificador</label>
                      <Input id='numero' name='numero' type='text' placeholder='Ex.: 101' onChange={this.onChange} value={unidade.numero || ''} />
                      <Erro text={errors.numero} />
                    </Form.Field>
                    {condominio.usarFracaoIdeal && (
                      <Form.Field error={!!errors.fracao} required>
                        <label htmlFor='fracao'>Fração ideal</label>
                        <Input id='fracao' name='fracao' type='number' min={0.0000000001} step={0.0000000001} max={1} placeholder='Ex.: 0.05' onChange={this.onChange} value={unidade.fracao || ''} />
                        <Erro text={errors.fracao} />
                      </Form.Field>
                    )}
                  </Form.Group>
                  <label className={`va-imp-opcao ${unidade.enviarTokenEmail ? 'ativa' : ''}`}>
                    <input type='checkbox' checked={!!unidade.enviarTokenEmail} onChange={this.onChangeTokenEmail} />
                    <span className='va-imp-chave' aria-hidden='true' />
                    <span>
                      <b>Enviar o token por e-mail ao salvar</b>
                      <small>O responsável recebe o token de acesso assim que você salvar as alterações.</small>
                    </span>
                  </label>
                  <Erro text={errors.enviarTokenEmail} />
                </section>

                <section className='va-imp-bloco'>
                  <h3><Icon name='user outline' /> Proprietário/Associado</h3>
                  {!!errorsResponsavel.responsavel && (
                    <div className='va-imp-resumo atencao'><Icon name='info circle' /><span>Não encontramos um proprietário com esse documento. Complete os dados abaixo para cadastrá-lo.</span></div>
                  )}
                  {!!loadingResponsavel && (
                    <div className='va-imp-resumo'><Icon name='spinner' loading /><span>Buscando proprietário...</span></div>
                  )}
                  {!!responsavelBuscadoExiste && (
                    <div className='va-imp-resumo ok'><Icon name='check circle' /><span>Proprietário encontrado — os dados foram preenchidos.</span></div>
                  )}
                  <Form.Group widths='equal'>
                    <Form.Field error={!!errorsResponsavel.documento || !!errors.documento}>
                      <label htmlFor='documento'>Documento (CPF ou CNPJ)</label>
                      <Input
                        type='text'
                        children={
                          <InputMask
                            id='documento'
                            name='documento'
                            placeholder='CPF ou CNPJ'
                            onInput={this.onChangeResponsavel}
                            value={formatDocumento(responsavel.documento)}
                            mask={responsavel.tipoDocumento === 'CPF' ? [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            disabled={loadingResponsavel}
                            readOnly={loadingResponsavel}
                            guide={true}
                          />
                        }
                      />
                      <Erro text={errorsResponsavel.documento || errors.documento} />
                    </Form.Field>
                    <Form.Field error={!!errors.nome}>
                      <label htmlFor='nome'>Nome completo</label>
                      <Input id='nome' name='nome' type='text' placeholder='Nome do proprietário' onChange={this.onChangeResponsavel} value={responsavel.nome || ''} loading={loadingResponsavel} disabled={this.disabledFields()} />
                      <Erro text={errors.nome} />
                    </Form.Field>
                  </Form.Group>
                  {!responsavelCadastrado ? (
                    <Form.Group widths='equal'>
                      <Form.Field error={!!errors.celular}>
                        <label htmlFor='celular'>Celular</label>
                        <InputMask
                          type='text'
                          id='celular'
                          name='celular'
                          placeholder='(ddd) número'
                          mask={['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          guide={true}
                          onChange={this.onChangeResponsavel}
                          value={responsavel.celular || ''}
                          disabled={this.disabledFields()}
                        />
                        <Erro text={errors.celular} />
                      </Form.Field>
                      <Form.Field error={!!errors.email}>
                        <label htmlFor='email'>E-mail</label>
                        <Input id='email' name='email' type='text' placeholder='E-mail' onChange={this.onChangeResponsavel} value={responsavel.email || ''} disabled={this.disabledFields()} />
                        <Erro text={errors.email} />
                      </Form.Field>
                    </Form.Group>
                  ) : (
                    (responsavel.celular || responsavel.email) && (
                      <div className='va-unidade-contato' style={{ marginTop: 4 }}>
                        {responsavel.celular && <span><Icon name='phone' /> {responsavel.celular}</span>}
                        {responsavel.email && <span><Icon name='mail outline' /> {responsavel.email}</span>}
                      </div>
                    )
                  )}
                  <p className='va-imp-dica'><Icon name='info circle' /> Para trocar o proprietário, digite o documento de outra pessoa. Os contatos de um proprietário já cadastrado são editados em "Proprietários".</p>
                </section>

                <div className='va-imp-acoes'>
                  <Button type='submit' loading={loading} disabled={loading} className='btn-ui-1' size='large'>
                    <Icon name='save' /> Salvar alterações
                  </Button>
                  <Link to={voltar} className='ui basic large button'>Cancelar</Link>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    unidade: state.unidade.unidade,
    responsavel: state.responsavel.responsavel,
    tiposDocumentos: state.responsavel.tiposDocumentos,
    errors: state.unidade.errors,
    errorsResponsavel: state.responsavel.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      findById,
      findByIdAndUpdate,
      findResponsavelByDocumento,
      resetStateResponsavel,
      reenviarEmailHash,
      gerarNovoHashUnidade
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditarUnidade);
